const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GrowManagementCommand: any = {
    UpdateGrowWarehouseInfos: Backofficebff + '/v1/grow/update-grow-warehouse-infos',
};
